<div class="selected-language-wrapper" (click)="showTheTooltip = !showTheTooltip; languageOptionsClosed = true;" cpClickOut (clickOut)="setInitialState();">
  <ng-container *ngIf="isAuthenticated; then userStrip; else languageStrip"></ng-container>
  <i #theAnchor class="pp-icon-collapse collapsible"></i>
</div>

<ng-template #languageStrip>
  <i class="pp-icon-language_selection"></i>
  <div class="text">{{selectedLanguage?.language}}</div>
</ng-template>

<ng-template #userStrip>
  <i class="pp-icon-info"></i>
  <div class="text">{{firstName}}</div>
</ng-template>

<ng-template #contactUsTitle>
  <div class="popup-title-container language-selection">
    <div class="popup-title-text">{{'ContactUs' | cpTitleTranslate | async}}</div>
    <i class="pp-icon-close popup-close" (click)="popupWindowService.closeLatestPopup()"></i>
  </div>
</ng-template>


<ng-template #aboutTitle>
  <div class="popup-title-container language-selection">
    <div class="popup-title-text">{{'About' | cpTitleTranslate | async}}</div>
    <i class="pp-icon-close popup-close" (click)="popupWindowService.closeLatestPopup()"></i>
  </div>
</ng-template>

<ng-template #changePasswordTitle>
  <div class="popup-title-container language-selection">
    <div class="popup-title-text">{{'ChangePassword' | cpLoginTranslate | async}}</div>
    <i class="pp-icon-close popup-close" (click)="popupWindowService.closeLatestPopup()"></i>
  </div>
</ng-template>

<app-tooltip *ngIf="showTheTooltip"
             class="bgc-white"
             [ngClass]="{'bgc-grey': isAuthenticated && languageOptionsClosed}"
             [anchor]="theAnchor"
             [width]="'200px'"
             [direction]="'top'"
             [contentPadding]="0"
             [forceOpen]="true">
  <div class="selected-language-tooltip-content-area collapsed" [ngClass]="{'expanded': !languageOptionsClosed}" *ngIf="isAuthenticated" (click)="languagesToggleHandler($event);">
    <ng-container *ngTemplateOutlet="languageStrip"></ng-container>
    <i class="pp-icon-collapse collapsible" *ngIf="!isAuthenticated || (isAuthenticated && languageOptionsClosed)"></i>
    <i class="pp-icon-expand collapsible" *ngIf="isAuthenticated && !languageOptionsClosed"></i>
  </div>
  <div class="selected-language-selection-items-wrapper" *ngIf="!isAuthenticated || (isAuthenticated && !languageOptionsClosed)">
    <app-language-selection-item *ngFor="let language of languages"
                                 [language]="language"
                                 [selected]="language === selectedLanguage"
                                 (languageSelected)="languageSelectedHandler($event);">
    </app-language-selection-item>
  </div>
  <div class="selected-language-tooltip-content-area" *ngIf="isAuthenticated" (click)="showContactUsPage();">
    <i class="pp-icon-info"></i>
    <div class="text">{{'ContactUs' | cpActionTranslate | async}}</div>
  </div>
  <div class="selected-language-tooltip-content-area" *ngIf="isAuthenticated && isInternalAuthentication" (click)="changePassword();">
    <i class="pp-icon-info"></i>
    <div class="text">{{'ChangePassword' | cpActionTranslate | async}}</div>
  </div>
  <div class="selected-language-tooltip-content-area" *ngIf="isAuthenticated" (click)="showAboutPage();">
    <i class="pp-icon-info"></i>
    <div class="text">{{'About' | cpActionTranslate | async}}</div>
  </div>
  <div class="selected-language-tooltip-content-area" *ngIf="isAuthenticated" (click)="logoutClickHandler();">
    <i class="pp-icon-close"></i>
    <div class="text">{{'Logout' | cpActionTranslate | async}}</div>
  </div>
</app-tooltip>
